import { useState } from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { Reveal } from "@/components/Reveal";
import { GALLERY_IMAGES } from "@/content/site";

export const Galerie = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section id="galerie" data-testid="gallery-section" className="scroll-mt-[var(--header-h)] section-pad bg-[hsl(var(--brand-paper-2))]">
      <div className="site-container">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="kicker">Einblicke in die Arbeit</p>
              <h2 className="mt-4 text-2xl font-semibold tracking-[-0.02em] text-foreground sm:text-3xl">
                Direkt von der Baustelle.
              </h2>
            </div>
            <p className="pb-1 text-xs text-muted-foreground">Eigene Projektaufnahmen &amp; Symbolbilder</p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 sm:gap-5">
          {GALLERY_IMAGES.map((image, index) => (
            <Reveal key={image.caption} delay={index * 0.05}>
              <button
                type="button"
                onClick={() => setSelected(image)}
                data-testid={`gallery-tile-button-${index + 1}`}
                aria-label={`Bild vergrössern: ${image.caption}`}
                className="tile group relative block w-full overflow-hidden text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.015] sm:aspect-[16/11]"
                />
                <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-black/0 opacity-0 transition-opacity duration-200 group-hover:opacity-100" aria-hidden="true" />
                <span className="pointer-events-none absolute inset-x-4 bottom-4 flex items-center justify-between opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                  <span className="text-sm font-medium text-white">{image.caption}</span>
                  <span className="font-tech text-[10px] uppercase tracking-[0.18em] text-white/80">{image.tag}</span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={Boolean(selected)} onOpenChange={(open) => !open && setSelected(null)}>
        <DialogContent
          data-testid="gallery-lightbox-dialog"
          aria-describedby={selected ? "gallery-lightbox-description" : undefined}
          className="max-w-4xl overflow-hidden rounded-[var(--radius-tile)] border-border/80 bg-card p-0"
        >
          {selected ? (
            <figure>
              <img src={selected.src} alt={selected.alt} className="max-h-[75vh] w-full object-cover" />
              <figcaption className="flex items-center justify-between px-6 py-4">
                <DialogTitle className="text-base font-semibold tracking-[-0.01em]">{selected.caption}</DialogTitle>
                <DialogDescription id="gallery-lightbox-description" className="font-tech text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  {selected.tag}
                </DialogDescription>
              </figcaption>
            </figure>
          ) : null}
          <DialogClose asChild>
            <button
              type="button"
              aria-label="Schliessen"
              data-testid="gallery-lightbox-close-button"
              className="absolute right-4 top-4 z-20 flex h-9 w-9 items-center justify-center rounded-full bg-black/50 text-white transition-colors duration-200 hover:bg-black/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
              <X className="h-4 w-4" />
            </button>
          </DialogClose>
        </DialogContent>
      </Dialog>
    </section>
  );
};